export default "__VITE_ASSET__EUvPyGYt__"